

















































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ConfigUsuarioStore, { TipoBuscaPessoa, TAMANHO_MINIMO_BUSCA_PESSOA, TAMANHO_CPF } from '@/components/Configuracoes/store/ConfigUsuarioStore'
import CadastroMedicoStore from '@/components/CadastroMedico/store/CadastroMedicoStore'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SuporteSecretariasStore from '@/components/Suporte/Store/SuporteSecretariasStore'
import { timeout, maskCPFCNPJ, validateCPF, validateEmail, onlyNumber, maskDate, maskHour } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'
import { DataTablePagination } from '@/types/_'
import _ from 'lodash'
import { UsuarioSeguranca } from '@/types/interfaces/Usuario'
import { defaultRoutes } from '@/router/routes'
import { SuporteFeedbackModalDataProps } from '@/components/modals/SuporteFeedbackModal.vue'
import ModalAlterarTipoUsuario from '@/components/Configuracoes/ModalAlterarTipoUsuario.vue'
import PainelUsuarioEspelho from '@/components/Configuracoes/painel-usuario-espelho.vue'
import Apis from '@/Apis/_'

@Component({
  components: {
    ModalAlterarTipoUsuario,
    PainelUsuarioEspelho,
  },
})
export default class ViewConfiguracaoUsuarios extends Vue {
  $refs!: {
    formUsuarioCadastro: any,
    formsContato: any,
    formAgendamento: any,
    formAgendamentoContato: any,
    formMedicoLocaisAtendimento: any,
    formAuth: any,
  }

  readyState: boolean = false
  loadEdit: string = ''
  loadAdd: boolean = false
  loadDelete: boolean = false
  loadSearch: boolean = false
  dialog: boolean = false
  addUsr: boolean = false
  dellUsr: boolean = false
  acao: string = 'Criar'
  tb: string = 'tab-1'
  ldSave: boolean = false
  ldCpf: boolean = false
  actLabel: string = 'Salvar no cadastro'
  msCpf: string = ''
  load: boolean = true
  userDel: string = ''
  btnSaveDisable: boolean = true
  mensagemErroUsuario: string = ''
  showSuporteFeedbackModal: boolean = false
  suporteFeedbackModalData: SuporteFeedbackModalDataProps[] = []

  showAlterarTipoModal: boolean = false
  ldAlterarTipo: string = ''
  alterarTipoUsuarioId: string = ''
  alterarTipoAtual: string = ''
  mostrarEspelho: boolean = false
  gruposEspelhados: string[] = []
  showConfirmaEspelhamento: boolean = false

  get hasEspelhamentoAplicado() {
    return this.gruposEspelhados.length > 0
  }

  get descricaoConfirmaEspelhamento() {
    const grupos = _.upperFirst(this.gruposEspelhados.join(', ').replace(/, ([^,]*)$/, ' e $1'))

    return `${grupos} deste usuário serão SUBSTITUÍDOS pelos do usuário espelho. O acesso atual dele nesses itens será perdido. Deseja salvar mesmo assim?`
  }

  confirmarSalvarEspelhamento() {
    this.showConfirmaEspelhamento = false
    this.gruposEspelhados = []
    this.gerenciarUsuario()
  }

  get dialogMaxWidth() {
    if (this.mostrarEspelho) {
      return '1400px'
    }

    return '650px'
  }

  get tituloDialogUsuario() {
    if (this.mostrarEspelho) {
      return `${this.acao} usuário por espelhamento`
    }

    return `${this.acao} usuário`
  }

  get MensagemCpf() { return this.msCpf }
  set MensagemCpf(value: string) { this.msCpf = value }
  get loadingSave() { return this.ldSave }
  set loadingSave(value: boolean) { this.ldSave = value }
  get actionLabel() { return this.actLabel }
  set actionLabel(value: string) { this.actLabel = value }
  get loadingCpf() { return this.ldCpf }
  set loadingCpf(value: boolean) { this.ldCpf = value }

  possuiAcessoSecretariaAgendamento: boolean = false
  possuiAcessoSecretariaAmbulatorio: boolean = false

  loadingLocaisAtendimento: boolean = false
  hospitaisConfigurados: any[] = []
  carregandoDadosSecretaria: boolean = false
  ignorarWatchHospitais: boolean = false

  usuarioCadastroRules: any = {
    valid: true,
    nome: [
      v => !!v || 'O campo Nome é obrigatório.',
    ],
    cpf: [
      v => !!v || 'O campo Cpf é obrigatório.',
      v => validateCPF(v) || 'Cpf inválido.',
    ],
    telefone: [
      v => !!v || 'O campo Celular é obrigatório.',
    ],
    crm: [],
    crmUf: [],
    dataNascimento: [],
    especialidade: [],
  }

  contatoRules: any = {
    valid: true,
    nome: [
      v => !!v || 'O campo Nome do Contato é obrigatório.',
    ],
    tipo: [
      v => !!v || 'O campo Tipo é obrigatório.',
    ],
    tipoContato: [
      v => !!v || 'O campo Tipo do Contato é obrigatório.',
    ],
    email: [
      v => !!v || 'O campo E-mail é obrigatório.',
      v => validateEmail(v) || 'E-mail inválido.',
    ],
    valor: [
      v => !!v || 'O campo Valor é obrigatório.',
    ],
  }

  agendamentoRulesDefault: any = {
    valid: true,
    nome: [v => !!v || 'O campo Nome é obrigatório.'],
    cpf: [
      v => !!v || 'O campo Cpf é obrigatório.',
      v => validateCPF(v) || 'Cpf inválido.',
    ],
    perfil: [
      v => (!!v && v.length > 0) || 'O campo Perfil é obrigatório',
    ],
    hospitais: [],
    operadoras: [],
    defaultPage: [],
    legacyProfile: [],
    permissoes: [],
    legacyPageAuthorized: [],
    legacyRoles: [],
    medico: [],
    localAtendimento: [],
  }

  agendamentoRules: any = { ...this.agendamentoRulesDefault }

  agendamentoContatoRules: any = {
    valid: true,
    email: [
      v => !!v || 'O campo E-mail é obrigatório.',
      v => validateEmail(v) || 'E-mail inválido.',
    ],
  }

  authRules: any = {
    valid: true,
    nome: [
      v => !!v || 'O campo Nome é obrigatório.',
    ],
    email: [
      v => !!v || 'O campo E-mail é obrigatório.',
      v => validateEmail(v) || 'E-mail inválido.',
    ],
    perfil: [
      v => !!v || 'O campo Perfil é obrigatório.',
    ],
  }

  get pagination() {
    return this.getConfigUsuarioStore.pagination
  }

  get tabs() {
    return this.tb
  }

  set tabs(value: string) {
    this.tb = value
  }

  async tabChange(e: string) {
    switch (e) {
      case 'tab-1':
        this.actionLabel = 'Salvar no cadastro'
        this.btnSaveDisable = true
        return true
      case 'tab-2':
        this.actionLabel = 'Salvar no agendamento'
        this.btnSaveDisable = true
        return true
      case 'tab-3':
        this.actionLabel = 'Salvar'
        this.btnSaveDisable = false
        return true
      default:
        return ''
    }
  }

  get getConfigUsuarioStore() {
    return getModule(ConfigUsuarioStore, this.$store)
  }

  get getCadastroMedicoStore() {
    return getModule(CadastroMedicoStore, this.$store)
  }

  get usuarios() {
    return this.getConfigUsuarioStore.usuarios
  }

  get hospitais() {
    return this.getSuporteSecretariasStore.hospitais.map(hospital => ({
      id: _.toUpper(hospital.hospitalId),
      nome: _.toUpper(hospital.hospitalNome),
    }))
  }

  get hasErroUsuario() {
    return !!this.mensagemErroUsuario
  }

  get permissoes() {
    return this.getConfigUsuarioStore.permissoes
  }

  get legacyPageAuthorized() {
    return defaultRoutes.map(page => page.meta.keyAuthorized)
  }

  get mappedDefaultPage() {
    return defaultRoutes.map(page => ({
      view: page.meta.keyAuthorized,
      KeyAuthorized: page.meta.keyAuthorized,
    }))
  }

  get legacyProfiles() {
    return this.getConfigUsuarioStore.legacyProfiles
  }

  get legacyRoles() {
    return this.getConfigUsuarioStore.legacyRoles
  }

  get operadoras() {
    return this.getConfigUsuarioStore.operadoras
  }

  get medicos() {
    return this.getConfigUsuarioStore.medicos
  }

  get loadingDeleteUser() {
    return this.loadDelete
  }

  set loadingDeleteUser(value: boolean) {
    this.loadDelete = value
  }

  get dellUser() {
    return this.dellUsr
  }

  set dellUser(value: boolean) {
    this.dellUsr = value
  }

  get addUser() {
    return this.addUsr
  }

  set addUser(value: boolean) {
    this.addUsr = value
  }

  get loadingCreateUser() {
    return this.loadAdd
  }

  set loadingCreateUser(value: boolean) {
    this.loadAdd = value
  }

  get loadingEditUser() {
    return this.loadEdit
  }

  set loadingEditUser(value: string) {
    this.loadEdit = value
  }

  get loadingSearchUser() {
    return this.loadSearch
  }

  set loadingSearchUser(value: boolean) {
    this.loadSearch = value
  }

  get loadingAlterarTipo() {
    return this.ldAlterarTipo
  }

  set loadingAlterarTipo(value: string) {
    this.ldAlterarTipo = value
  }

  get getTableHeader() {
    return this.getConfigUsuarioStore.configUsuariosTableHeader
  }

  get getUf() {
    const ufs: any[] = []
    ufs.push({ id: 'AC', value: 'AC' })
    ufs.push({ id: 'AL', value: 'AL' })
    ufs.push({ id: 'AP', value: 'AP' })
    ufs.push({ id: 'AM', value: 'AM' })
    ufs.push({ id: 'BA', value: 'BA' })
    ufs.push({ id: 'CE', value: 'CE' })
    ufs.push({ id: 'DF', value: 'DF' })
    ufs.push({ id: 'ES', value: 'ES' })
    ufs.push({ id: 'GO', value: 'GO' })
    ufs.push({ id: 'MA', value: 'MA' })
    ufs.push({ id: 'MT', value: 'MT' })
    ufs.push({ id: 'MS', value: 'MS' })
    ufs.push({ id: 'MG', value: 'MG' })
    ufs.push({ id: 'PA', value: 'PA' })
    ufs.push({ id: 'PB', value: 'PB' })
    ufs.push({ id: 'PR', value: 'PR' })
    ufs.push({ id: 'PE', value: 'PE' })
    ufs.push({ id: 'PI', value: 'PI' })
    ufs.push({ id: 'RJ', value: 'RJ' })
    ufs.push({ id: 'RN', value: 'RN' })
    ufs.push({ id: 'RS', value: 'RS' })
    ufs.push({ id: 'RO', value: 'RO' })
    ufs.push({ id: 'RR', value: 'RR' })
    ufs.push({ id: 'SC', value: 'SC' })
    ufs.push({ id: 'SP', value: 'SP' })
    ufs.push({ id: 'SE', value: 'SE' })
    ufs.push({ id: 'TO', value: 'TO' })
    return ufs
  }

  get getDataNascimento() {
    if (this.getConfigUsuarioStore.usuarioAgendamento.dadosPessoa.dataNascimento) {
      return moment(this.getConfigUsuarioStore.usuarioAgendamento.dadosPessoa.dataNascimento).format('DDMMYYYY')
    }
    return ''
  }

  set getDataNascimento(value: string) {
    if (value && value.length === 8) {
      const date = moment(value, 'DDMMYYYY').toISOString()
      this.getConfigUsuarioStore.setDataNascimento(date)
    } else {
      this.getConfigUsuarioStore.setDataNascimento('')
    }
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSuporteSecretariasStore() {
    return getModule(SuporteSecretariasStore, this.$store)
  }

  get getRequestMessage() {
    return this.getSolicitacaoStore.requestMessage
  }

  get perfils() {
    const perfilAtual = this.getConfigUsuarioStore.usuarioAgendamento.tipoUsuarioAgendamento

    if (this.acao === 'Criar' || perfilAtual === 'UsuarioBackoffice') {
      return [
        { id: 'UsuarioBackoffice', text: 'Usuário Backoffice' },
      ]
    }

    return [
      { id: 'UsuarioBackoffice', text: 'Usuário Backoffice' },
      { id: 'SecretariaDoAgendamento', text: 'Secretária agendamento' },
      { id: 'SecretariaDoAmbulatorio', text: 'Secretária ambulatório' },
    ]
  }

  get disabledPerfil() {
    return ['Medico', 'SecretariaDoMedico', 'SecretariaDoAmbulatorio', 'SecretariaDoAgendamento']
  }

  get habilitarSecretariaMedico() {
    return ['SecretariaDoAgendamento', 'SecretariaDoAmbulatorio']
  }

  pessoaPagedDebounce = _.debounce(async (param) => {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.post })
    await this.getConfigUsuarioStore.getPessoalAll(param)
    EventBus.$emit('clearLoadingRequest')
  }, 1100)

  async updatePagination(pagination: DataTablePagination) {
    // O v-data-table emite update:pagination já na montagem. Sem esse guard a tela
    // buscava sozinha ao abrir — era essa a origem da busca inicial (FXCS-6701).
    if (!this.getConfigUsuarioStore.buscaPessoaRealizada) return
    await this.pessoaPagedDebounce(pagination)
  }

  get pages() {
    if (this.pagination.rowsPerPage === null || this.pagination.totalItems === null) return 0
    return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
  }

  async getResults(page: number) {
    await this.getConfigUsuarioStore.getPessoalAll({
      descending: false,
      page,
      rowsPerPage: this.pagination.rowsPerPage || 10,
      sortBy: null,
      totalItems: 0,
      rowsPerPageItems: [10, 50, 100, 200],
    })
  }

  get searchPessoa() {
    return this.getConfigUsuarioStore.searchPessoa
  }

  set searchPessoa(value: string) {
    this.getConfigUsuarioStore.setSearchPessoa(value)
  }

  get tipoBusca() {
    return this.getConfigUsuarioStore.tipoBuscaPessoa
  }

  set tipoBusca(value: TipoBuscaPessoa) {
    this.getConfigUsuarioStore.setTipoBuscaPessoa(value)
  }

  get opcoesDeBusca() {
    return [
      { text: 'Nome', value: 'nome' },
      { text: 'E-mail', value: 'email' },
      { text: 'CPF', value: 'cpf' },
    ]
  }

  /**
   * Espelha o validator do backend: CPF exige os 11 dígitos (a busca é por
   * igualdade, CPF parcial não encontraria nada); nome e e-mail, 3 caracteres.
   */
  get buscaHabilitada() {
    return this.tipoBusca === 'cpf'
      ? this.termoDeBusca.length === TAMANHO_CPF
      : this.termoDeBusca.length >= TAMANHO_MINIMO_BUSCA_PESSOA
  }

  /** Para CPF o tamanho vale sobre os dígitos, não sobre a máscara. */
  get termoDeBusca() {
    const termo = (this.searchPessoa || '').trim()
    return this.tipoBusca === 'cpf' ? termo.replace(/\D/g, '') : termo
  }

  get rotuloDoCampo() {
    if (this.tipoBusca === 'email') return 'E-mail'
    if (this.tipoBusca === 'cpf') return 'CPF'
    return 'Nome'
  }

  get exemploDoCampo() {
    if (this.tipoBusca === 'email') return 'maria@hospital.com.br'
    if (this.tipoBusca === 'cpf') return '123.456.789-00'
    return 'silva'
  }

  /**
   * A regra do e-mail é a única que surpreende: o @ muda o tipo de busca.
   * Fica visível por padrão (persistent-hint), não escondida atrás de hover.
   */
  get dicaDoCampo() {
    if (this.tipoBusca === 'email') {
      return 'Com @ busca o e-mail exato. Sem @ busca qualquer parte — ex.: "hospital".'
    }

    if (this.tipoBusca === 'cpf') return 'CPF completo, com ou sem pontuação.'

    return 'Busca por qualquer parte do nome.'
  }

  get mensagemGradeVazia() {
    if (this.loadingSearchUser) return 'Buscando usuários...'

    return this.getConfigUsuarioStore.buscaPessoaRealizada
      ? 'Nenhum usuário encontrado para essa busca.'
      : `Escolha Nome, E-mail ou CPF, digite ao menos ${TAMANHO_MINIMO_BUSCA_PESSOA} caracteres e clique em Pesquisar.`
  }

  /** Trocar de campo invalida o termo digitado para o campo anterior. */
  onTipoBuscaChange() {
    this.searchPessoa = ''
  }

  addMedicoLocalAtendimento() {
    if (this.$refs.formAgendamento.validate()) {
      this.getConfigUsuarioStore.addMedicoLocalAtendimento()
    }
  }

  async medicoChange(id: string) {
    const response = await this.getConfigUsuarioStore.getAllLocalAtendimentoByMedicoId(id)
    if (response.success) {
      this.getConfigUsuarioStore.updateMedico()
      this.getConfigUsuarioStore.clearLocalAtendimento(id)
    }
  }

  async removeMedicoLocalAtendimento(index: number) {
    this.getConfigUsuarioStore.removeMedicoLocalAtendimento(index)
    this.getConfigUsuarioStore.updateMedico()
  }

  async makeSearch() {
    if (!this.buscaHabilitada) return

    this.getConfigUsuarioStore.setBuscaPessoaRealizada(true)
    await this.buscarPagina(1)
  }

  /**
   * Pesquisar e trocar de página se comportam igual: limpa a grade e mostra o
   * loading enquanto busca. A paginação fica, porque o total só muda na resposta (FXCS-6701).
   */
  async buscarPagina(page: number) {
    this.getConfigUsuarioStore.clearUsuarios()
    this.loadingSearchUser = true
    await this.getResults(page)
    this.loadingSearchUser = false
  }

  perfilChange(perfil: string) {
    this.getConfigUsuarioStore.clearPerfilChange()
    this.$refs.formAgendamento.resetValidation()
    this.perfilRules(perfil)
  }

  perfilRules(perfil: string) {
    this.agendamentoRules = { ...this.agendamentoRulesDefault }

    switch (perfil) {
      case 'SecretariaDoMedico':
        this.agendamentoRules.medico.push(v => !!v || 'O campo Médico é obrigatório')
        this.agendamentoRules.localAtendimento.push(v => (!!v && v.length > 0) || 'O campo Local de Atendimento é obrigatório')
        break

      default:
        this.agendamentoRules.hospitais.push(v => (!!v && v.length > 0) || 'O campo Perfil é obrigatório')
        break
    }
  }

  removeHospital(id: string) {
    this.getConfigUsuarioStore.removeHospital(id)
  }

  removeOperadora(id: string) {
    this.getConfigUsuarioStore.removeOperadora(id)
  }

  removePermission(permission: string) {
    this.getConfigUsuarioStore.removePermission(permission)
  }

  removeLegacyPageAuthorized(permission: string) {
    this.getConfigUsuarioStore.removeLegacyPageAuthorized(permission)
  }

  removeLegacyRoles(permission: string) {
    this.getConfigUsuarioStore.removeLegacyRoles(permission)
  }

  habilitarMedicoChange(value: boolean) {
    if (value) {
      this.usuarioCadastroRules.crm.push(v => !!v || 'O campo Crm é obrigatório.')
      this.usuarioCadastroRules.crmUf.push(v => !!v || 'O campo Crm-Uf é obrigatório.')
      this.usuarioCadastroRules.especialidade.push(v => (!!v && v.length > 0) || 'O campo Especialidades é obrigatório.')
    } else {
      this.usuarioCadastroRules.crm = []
      this.usuarioCadastroRules.crmUf = []
      this.usuarioCadastroRules.especialidade = []
      this.getConfigUsuarioStore.clearCamposMedico()
    }
  }

  habilitarMedicoRule() {
    this.habilitarMedicoChange(this.getConfigUsuarioStore.usuarioAgendamento.habilitarMedico)
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  removerEspecialidade(id: string) {
    this.getConfigUsuarioStore.removeEspecialidade(id)
  }

  maskCPFCNPJUtil(value: string) {
    return maskCPFCNPJ(value)
  }

  dateMask(value: string) {
    return maskDate(value)
  }

  hourMask(value: string) {
    return maskHour(value)
  }

  formatDataExclusao(value: string) {
    if (!value) {
      return '-'
    }

    return `${maskDate(value)} ${maskHour(value)}`
  }

  showModalEditarUser(value: boolean) {
    this.dialog = value
  }

  addEmail() {
    const valid = this.contatoValidate()
  }

  contatoValidate() {
    let valid: boolean = true
    try {
      for (let i = 0; i < this.$refs.formsContato.length; i++) {
        if (!this.$refs.formsContato[i].validate()) {
          valid = false
        }
      }
    } catch (error) {
      // todo
    }

    return valid
  }

  agendamentoContatoValidate() {
    let valid: boolean = true
    if (this.$refs.formAgendamentoContato) {
      for (let i = 0; i < this.$refs.formAgendamentoContato.length; i++) {
        if (!this.$refs.formAgendamentoContato[i].validate()) {
          valid = false
        }
      }
    }
    return valid
  }

  /**
   * Hospitais e operadoras só aparecem no modal de usuário: carrega ao abrir o
   * modal, não ao abrir a tela. Lista vazia tenta de novo na próxima abertura (FXCS-6701).
   */
  async carregarListasDoModal() {
    if (_.isEmpty(this.hospitais)) await this.getSuporteSecretariasStore.getAllHospitalSuporteConfiguracao()
    if (_.isEmpty(this.operadoras)) await this.getConfigUsuarioStore.getAllOperadoras()
  }

  async createUser(acao: string) {
    this.loadingCreateUser = true
    this.acao = acao
    await this.carregarListasDoModal()
    await this.getConfigUsuarioStore.getPermissoes()
    this.addUser = true
    this.loadingCreateUser = false
  }

  async editUser(id: string, acao: string) {
    this.loadingEditUser = id
    this.acao = acao
    const response = await this.getConfigUsuarioStore.getPessoaById(id)

    if (!response.success) {
      this.mensagemErroUsuario = response.message || 'Não foi possível carregar o usuário.'
      this.addUser = true
      this.loadingEditUser = ''
      return
    }

    await this.carregarListasDoModal()
    await this.getConfigUsuarioStore.getPermissoes()
    this.habilitarMedicoRule()
    await this.verificarEAtivarSwitchesSecretaria()
    this.$refs.formUsuarioCadastro.resetValidation()
    this.$refs.formAgendamento.resetValidation()
    this.addUser = true
    this.loadingEditUser = ''
  }

  async verificarEAtivarSwitchesSecretaria() {
    const legacyRoles = this.getConfigUsuarioStore.usuarioAgendamento.dadosUsuarioSeguranca.legacyRoles || []
    const tipoUsuario = this.getConfigUsuarioStore.usuarioAgendamento.tipoUsuarioAgendamento

    const temRoleAgendamento = legacyRoles.includes('secretariaDoAgendamentoBackoffice')
    const temRoleAmbulatorio = legacyRoles.includes('secretariaDoAmbulatorioBackoffice')

    if (tipoUsuario === 'UsuarioBackoffice') {
      this.possuiAcessoSecretariaAgendamento = temRoleAgendamento
      this.possuiAcessoSecretariaAmbulatorio = temRoleAmbulatorio
    } else if (tipoUsuario === 'SecretariaDoAgendamento') {
      this.possuiAcessoSecretariaAgendamento = temRoleAgendamento
      this.possuiAcessoSecretariaAmbulatorio = false
    } else if (tipoUsuario === 'SecretariaDoAmbulatorio') {
      this.possuiAcessoSecretariaAgendamento = false
      this.possuiAcessoSecretariaAmbulatorio = temRoleAmbulatorio
    } else {
      this.possuiAcessoSecretariaAgendamento = false
      this.possuiAcessoSecretariaAmbulatorio = false
    }

    const userId = this.getConfigUsuarioStore.usuarioAgendamento.dadosPessoa.id
    if (userId) {
      const ehSecretariaAgendamento = tipoUsuario === 'SecretariaDoAgendamento'
      const ehSecretariaAmbulatorio = tipoUsuario === 'SecretariaDoAmbulatorio'

      if (ehSecretariaAgendamento || (temRoleAgendamento && !ehSecretariaAmbulatorio)) {
        await this.carregarDadosSecretaria(userId)
      }

      if (ehSecretariaAmbulatorio || (temRoleAmbulatorio && !ehSecretariaAgendamento)) {
        await this.carregarDadosSecretariaAmbulatorio(userId)
      }
    }
  }

  async carregarDadosSecretaria(userId: string) {
    this.ignorarWatchHospitais = true

    try {
      const response = await this.getSuporteSecretariasStore.getSecretariaById(userId)

      if (response.success && this.getSuporteSecretariasStore.secretaria) {
        const { secretaria } = this.getSuporteSecretariasStore

        if (!this.getConfigUsuarioStore.usuarioAgendamento.dadosPessoa.telefone && secretaria.telefone) {
          this.getConfigUsuarioStore.usuarioAgendamento.dadosPessoa.telefone = secretaria.telefone
        }
      }
    } catch (error) {
      console.error('Erro ao carregar dados da secretária:', error)
    } finally {
      this.$nextTick(() => {
        this.ignorarWatchHospitais = false
      })
    }
  }

  async carregarDadosSecretariaAmbulatorio(userId: string) {
    this.ignorarWatchHospitais = true

    try {
      this.carregandoDadosSecretaria = true

      const response = await this.getSuporteSecretariasStore.getSecretariaById(userId)

      if (response.success && this.getSuporteSecretariasStore.secretaria) {
        const { secretaria } = this.getSuporteSecretariasStore

        if (!this.getConfigUsuarioStore.usuarioAgendamento.dadosPessoa.telefone && secretaria.telefone) {
          this.getConfigUsuarioStore.usuarioAgendamento.dadosPessoa.telefone = secretaria.telefone
        }

        if (secretaria.hospitais && secretaria.hospitais.length > 0) {
          const hospitaisSelecionados = this.getConfigUsuarioStore.usuarioAgendamento.hospitais || []
          const locaisSalvosMap = new Map()

          secretaria.hospitais.forEach((hospitalSecretaria: any) => {
            const hospitalId = _.toUpper(hospitalSecretaria.hospitalId)

            if (hospitalSecretaria.locaisAtendimento && hospitalSecretaria.locaisAtendimento.length > 0) {
              const locaisDoHospital = hospitalSecretaria.locaisAtendimento.map((local: any) => ({
                id: local.id,
                nome: local.nome,
                naoEditarInformacoesAdicionais: local.naoEditarInformacoesAdicionais || false,
              }))
              locaisSalvosMap.set(hospitalId, locaisDoHospital)
            }
          })

          if (hospitaisSelecionados.length > 0) {
            await this.carregarLocaisParaHospitaisSelecionados(hospitaisSelecionados, locaisSalvosMap)
          }
        }
      }
    } catch (error) {
      console.error('Erro ao carregar dados da secretária do ambulatório:', error)
    } finally {
      this.carregandoDadosSecretaria = false

      this.$nextTick(() => {
        this.ignorarWatchHospitais = false
      })
    }
  }

  async carregarLocaisParaHospitaisSelecionados(hospitaisIds: string[], locaisSalvosMap: Map<string, any[]>) {
    try {
      const response = await Apis.Agendamento.SuporteApi.getAllLocaisDeAtendimentoEMedicos(hospitaisIds)

      if (response.success && response.data && response.data.locaisAtendimento) {
        const hospitaisMap = new Map()

        response.data.locaisAtendimento.forEach((local: any) => {
          const hospitalId = _.toUpper(local.hospitalId)

          if (!hospitaisMap.has(hospitalId)) {
            const hospital = this.hospitais.find(h => h.id === hospitalId)
            if (hospital) {
              hospitaisMap.set(hospitalId, {
                hospitalId: hospital.id,
                hospitalNome: hospital.nome,
                locais: [],
                locaisAtendimento: [],
              })
            }
          }

          const hospitalConfig = hospitaisMap.get(hospitalId)
          if (hospitalConfig) {
            hospitalConfig.locais.push({
              id: local.id,
              nome: local.nome,
              hospitalId,
              naoEditarInformacoesAdicionais: false,
            })
          }
        })

        hospitaisMap.forEach((hospitalConfig, hospitalId) => {
          const locaisSalvos = locaisSalvosMap.get(hospitalId)
          if (locaisSalvos) {
            hospitalConfig.locaisAtendimento = hospitalConfig.locais.filter((local: any) =>
              locaisSalvos.some((salvo: any) => salvo.id === local.id),
            )

            hospitalConfig.locaisAtendimento.forEach((local: any) => {
              const localSalvo = locaisSalvos.find((s: any) => s.id === local.id)
              if (localSalvo) {
                local.naoEditarInformacoesAdicionais = localSalvo.naoEditarInformacoesAdicionais
              }
            })
          }
        })

        this.hospitaisConfigurados = Array.from(hospitaisMap.values())
      }
    } catch (error) {
      console.error('Erro ao carregar locais de atendimento:', error)
    }
  }

  closeAddUser() {
    this.addUser = false
    this.tabs = 'tab-1'
    this.getConfigUsuarioStore.clearUsuarioAgendamento()
    this.$refs.formUsuarioCadastro.reset()
    this.getConfigUsuarioStore.setDataNascimento('')
    this.$refs.formAgendamento.reset()
    this.$refs.formAuth.reset()
    if (this.$refs.formsContato) this.$refs.formsContato.map(c => c.reset())
    this.possuiAcessoSecretariaAgendamento = false
    this.possuiAcessoSecretariaAmbulatorio = false
    this.hospitaisConfigurados = []
    this.mensagemErroUsuario = ''
    this.mostrarEspelho = false
    this.gruposEspelhados = []
  }

  closeDellUser() {
    this.dellUser = false
  }

  dialogDell(id: string) {
    this.dellUser = true
    this.userDel = id
  }

  async deleteUser() {
    this.loadingDeleteUser = true
    const response = await this.getConfigUsuarioStore.deletePessoa(this.userDel)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Usuário apagado com sucesso! ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32' })
      await this.getConfigUsuarioStore.getPessoalAll(this.getConfigUsuarioStore.pagination)
      this.userDel = ''
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: `Ocorreu um erro na requisição ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
    }

    this.loadingDeleteUser = false
    this.dellUser = false
  }

  async gerenciarUsuario() {
    if (this.hasEspelhamentoAplicado) {
      this.showConfirmaEspelhamento = true
      return false
    }

    switch (this.tabs) {
      case 'tab-1':
        this.loadingSave = true
        await this.salvar()
        this.loadingSave = false
        return false
      case 'tab-2':
        this.loadingSave = true
        await this.salvar()
        this.loadingSave = false
        return false
      case 'tab-3':
        this.loadingSave = true
        await this.salvar()
        this.loadingSave = false
        return false
      default:
        this.loadingSave = true
        await timeout(2000)
        this.loadingSave = false
    }
    return false
  }

  async enviarCadastro() {
    const usuarioValidate = this.$refs.formUsuarioCadastro.validate()
    const contatoValidate = this.contatoValidate()
    if (usuarioValidate && contatoValidate) {
      const response = await this.getConfigUsuarioStore.usuarioAgendamentoUpsert()
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Dados enviado com sucesso!', icon: 'done', color: '#2E7D32' })
        await this.getConfigUsuarioStore.getPessoalAll(this.getConfigUsuarioStore.pagination)
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu erro ao enviar os dados.', icon: 'warning', color: '#C62828' })
      }
    }
  }

  async enviarAgendamento() {
    if (this.getConfigUsuarioStore.usuarioAgendamento.tipoUsuarioAgendamento !== 'UsuarioBackoffice') {
      EventBus.$emit('setSnackbar', { show: true, text: 'Por equanto somente perfil backoffice está liberado.', icon: 'warning', color: '#C62828' })
      return
    }

    const usuarioValidate = this.$refs.formAgendamento.validate()
    const contatoValidate = this.agendamentoContatoValidate()
    if (usuarioValidate && contatoValidate) {
      const response = await this.getConfigUsuarioStore.usuarioAgendamentoUpsert()
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Dados enviado com sucesso!', icon: 'done', color: '#2E7D32' })
        await this.getConfigUsuarioStore.getPessoalAll(this.getConfigUsuarioStore.pagination)
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu erro ao enviar os dados.', icon: 'warning', color: '#C62828' })
      }
    }
  }

  async enviarAuth() {
    if (this.getConfigUsuarioStore.usuarioAgendamento.tipoUsuarioAgendamento !== 'UsuarioBackoffice') {
      EventBus.$emit('setSnackbar', { show: true, text: 'Por equanto somente perfil backoffice está liberado.', icon: 'warning', color: '#C62828' })
      return
    }

    const authValidate = this.$refs.formAuth.validate()
    if (authValidate) {
      const response = await this.getConfigUsuarioStore.usuarioAgendamentoUpsert()
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Dados enviado com sucesso!', icon: 'done', color: '#2E7D32' })
        await this.getConfigUsuarioStore.getPessoalAll(this.getConfigUsuarioStore.pagination)
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu erro ao enviar os dados.', icon: 'warning', color: '#C62828' })
      }
    }
  }

  onCloseSuporteFeedbackModal() {
    this.closeAddUser()
    this.showSuporteFeedbackModal = false
    this.suporteFeedbackModalData = []
  }

  async openAlterarTipoModal(item: any) {
    this.loadingAlterarTipo = item.id
    try {
      const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getTipoUsuario(item.id)
      if (!response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu erro ao buscar o tipo do usuário.', icon: 'warning', color: '#C62828' })
        return
      }
      this.alterarTipoUsuarioId = item.id
      this.alterarTipoAtual = response.data && response.data.tipo ? response.data.tipo : ''
      this.showAlterarTipoModal = true
    } finally {
      this.loadingAlterarTipo = ''
    }
  }

  closeAlterarTipoModal() {
    this.showAlterarTipoModal = false
    this.alterarTipoUsuarioId = ''
    this.alterarTipoAtual = ''
  }

  onConfirmAlterarTipo(_novoTipo: string) {
    this.closeAlterarTipoModal()
  }

  async salvar() {
    const usuarioCadastroValidate = this.$refs.formUsuarioCadastro.validate()

    const contatoCadastroValidate = this.contatoValidate()

    const usuarioAgendamentoValidate = this.$refs.formAgendamento.validate()

    const contatoAgendamentoValidate = this.agendamentoContatoValidate()

    const usuarioAuthValidate = this.$refs.formAuth.validate()

    const isDefaultPageAuth = this.isDefaultPageAuthorized(this.getConfigUsuarioStore.usuarioAgendamento.dadosUsuarioSeguranca)

    if (!isDefaultPageAuth) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Default Page precisa estar entre as permissões de Pages Authorized.', icon: 'warning', color: '#C62828' })
      return
    }

    if (usuarioCadastroValidate
    && contatoCadastroValidate
    && usuarioAgendamentoValidate
    && contatoAgendamentoValidate
    && usuarioAuthValidate) {
      this.prepararHospitalLocalAtendimento()

      const response = await this.getConfigUsuarioStore.usuarioAgendamentoUpsert()

      if (response.success) {
        await this.getConfigUsuarioStore.getPessoalAll(this.getConfigUsuarioStore.pagination)
        this.suporteFeedbackModalData = response.data
        this.showSuporteFeedbackModal = true
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu erro ao enviar os dados.', icon: 'warning', color: '#C62828' })
      }
    }
  }

  isDefaultPageAuthorized(dadosSegranca: UsuarioSeguranca): boolean {
    return dadosSegranca.legacyPageAuthorized.includes(dadosSegranca.defaultPage.view)
  }

  restaurarLocaisAtendimentoSelecionados() {
    const { hospitalLocalAtendimento } = this.getConfigUsuarioStore.usuarioAgendamento
    if (!hospitalLocalAtendimento || hospitalLocalAtendimento.length === 0) return

    this.hospitaisConfigurados.forEach((hospitalConfig) => {
      const dadosSalvos = hospitalLocalAtendimento.find(h => h.hospitalId === hospitalConfig.hospitalId)
      if (dadosSalvos && dadosSalvos.localAtendimentoId) {
        hospitalConfig.locaisAtendimento = hospitalConfig.locais.filter((local: any) => (
          dadosSalvos.localAtendimentoId.includes(local.id)
        ))

        if (dadosSalvos.naoEditarInformacoesAdicionais) {
          hospitalConfig.locaisAtendimento.forEach((local: any) => {
            if (dadosSalvos.naoEditarInformacoesAdicionais && dadosSalvos.naoEditarInformacoesAdicionais[local.id]) {
              local.naoEditarInformacoesAdicionais = true
            }
          })
        }
      }
    })
  }

  prepararHospitalLocalAtendimento() {
    const tipoUsuario = this.getConfigUsuarioStore.usuarioAgendamento.tipoUsuarioAgendamento
    const ehSecretariaAmbulatorio = tipoUsuario === 'SecretariaDoAmbulatorio' || this.possuiAcessoSecretariaAmbulatorio

    if (!ehSecretariaAmbulatorio) {
      this.getConfigUsuarioStore.usuarioAgendamento.hospitalLocalAtendimento = []
      return
    }

    this.getConfigUsuarioStore.usuarioAgendamento.hospitalLocalAtendimento = this.hospitaisConfigurados
      .filter(hospital => hospital.locaisAtendimento && hospital.locaisAtendimento.length > 0)
      .map((hospital) => {
        const temNaoEditar = hospital.locaisAtendimento.some((local: any) => local.naoEditarInformacoesAdicionais === true)

        return JSON.parse(JSON.stringify({
          hospitalId: hospital.hospitalId,
          localAtendimentoId: hospital.locaisAtendimento.map((local: any) => local.id),
          naoEditarInformacoesAdicionais: temNaoEditar,
        }))
      })
  }

  possuiAcessoSecretariaAgendamentoChange() {
    if (this.possuiAcessoSecretariaAgendamento) {
      this.getConfigUsuarioStore.removeLegacyRoles('secretariaDoAmbulatorioBackoffice')
      this.getConfigUsuarioStore.addLegacyRoles('secretariaDoAgendamentoBackoffice')
      this.getConfigUsuarioStore.addLegacyRoles('instrumentador')
    } else {
      this.getConfigUsuarioStore.removeLegacyRoles('secretariaDoAgendamentoBackoffice')
      this.getConfigUsuarioStore.removeLegacyRoles('instrumentador')
    }
  }

  possuiAcessoSecretariaAmbulatorioChange() {
    const tipoUsuario = this.getConfigUsuarioStore.usuarioAgendamento.tipoUsuarioAgendamento

    if (this.possuiAcessoSecretariaAmbulatorio) {
      this.getConfigUsuarioStore.removeLegacyRoles('secretariaDoAgendamentoBackoffice')
      this.getConfigUsuarioStore.addLegacyRoles('secretariaDoAmbulatorioBackoffice')
      this.getConfigUsuarioStore.addLegacyRoles('instrumentador')

      if (tipoUsuario !== 'SecretariaDoAmbulatorio') {
        this.carregarLocaisAtendimentoHospitais()
      }
    } else {
      this.getConfigUsuarioStore.removeLegacyRoles('secretariaDoAmbulatorioBackoffice')
      this.getConfigUsuarioStore.removeLegacyRoles('instrumentador')

      if (tipoUsuario !== 'SecretariaDoAmbulatorio') {
        this.hospitaisConfigurados = []
      }
    }
  }

  async carregarLocaisAtendimentoHospitais() {
    this.loadingLocaisAtendimento = true

    try {
      const hospitaisSelecionados = this.getConfigUsuarioStore.usuarioAgendamento.hospitais || []

      if (hospitaisSelecionados.length === 0) {
        this.hospitaisConfigurados = []
        return
      }

      const response = await Apis.Agendamento.SuporteApi.getAllLocaisDeAtendimentoEMedicos(hospitaisSelecionados)

      if (response.success && response.data && response.data.locaisAtendimento) {
        const hospitaisMap = new Map()

        response.data.locaisAtendimento.forEach((local: any) => {
          const hospitalId = _.toUpper(local.hospitalId)

          if (!hospitaisMap.has(hospitalId)) {
            const hospital = this.hospitais.find(h => h.id === hospitalId)
            if (hospital) {
              hospitaisMap.set(hospitalId, {
                hospitalId: hospital.id,
                hospitalNome: hospital.nome,
                locais: [],
                locaisAtendimento: [],
              })
            }
          }

          const hospitalConfig = hospitaisMap.get(hospitalId)
          if (hospitalConfig) {
            hospitalConfig.locais.push({
              id: local.id,
              nome: local.nome,
              hospitalId,
              naoEditarInformacoesAdicionais: false,
            })
          }
        })

        this.hospitaisConfigurados = Array.from(hospitaisMap.values())
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Ocorreu um erro ao buscar locais de atendimento',
        icon: 'warning',
        color: '#C62828',
      })
    } finally {
      this.loadingLocaisAtendimento = false
    }
  }

  removeLocalAtendimento(hospitalId: string, local: any) {
    const hospital = this.hospitaisConfigurados.find(h => h.hospitalId === hospitalId)
    if (hospital && hospital.locaisAtendimento) {
      const index = hospital.locaisAtendimento.findIndex(l => l.id === local.id)
      if (index > -1) {
        hospital.locaisAtendimento.splice(index, 1)
      }
    }
  }

  @Watch('getConfigUsuarioStore.usuarioAgendamento.hospitais')
  onHospitaisChange(newHospitais: string[]) {
    const tipoUsuario = this.getConfigUsuarioStore.usuarioAgendamento.tipoUsuarioAgendamento
    const ehSecretariaAmbulatorio = tipoUsuario === 'SecretariaDoAmbulatorio' || this.possuiAcessoSecretariaAmbulatorio

    if (!ehSecretariaAmbulatorio) return
    if (this.ignorarWatchHospitais) return

    this.$nextTick(() => {
      this.sincronizarHospitaisConfigurados(newHospitais || [])
    })
  }


  @Watch('getConfigUsuarioStore.usuarioAgendamento.dadosUsuarioSeguranca.legacyRoles', { deep: true })
  onLegacyRolesChange(newRoles: string[], oldRoles: string[]) {
    if (!newRoles) return

    const temRoleAgendamento = newRoles.includes('secretariaDoAgendamentoBackoffice')
    const temRoleAmbulatorio = newRoles.includes('secretariaDoAmbulatorioBackoffice')

    if (temRoleAgendamento && temRoleAmbulatorio) {
      const oldTemAgendamento = oldRoles && oldRoles.includes('secretariaDoAgendamentoBackoffice')
      const oldTemAmbulatorio = oldRoles && oldRoles.includes('secretariaDoAmbulatorioBackoffice')

      if (!oldTemAgendamento && oldTemAmbulatorio) {
        this.$nextTick(() => {
          this.getConfigUsuarioStore.removeLegacyRoles('secretariaDoAmbulatorioBackoffice')
        })
        return
      }

      if (!oldTemAmbulatorio && oldTemAgendamento) {
        this.$nextTick(() => {
          this.getConfigUsuarioStore.removeLegacyRoles('secretariaDoAgendamentoBackoffice')
        })
        return
      }
    }

    if (temRoleAgendamento && !this.possuiAcessoSecretariaAgendamento) {
      this.possuiAcessoSecretariaAgendamento = true
    } else if (!temRoleAgendamento && this.possuiAcessoSecretariaAgendamento) {
      this.possuiAcessoSecretariaAgendamento = false
    }

    if (temRoleAmbulatorio && !this.possuiAcessoSecretariaAmbulatorio) {
      this.possuiAcessoSecretariaAmbulatorio = true
      if (this.getConfigUsuarioStore.usuarioAgendamento.hospitais && this.getConfigUsuarioStore.usuarioAgendamento.hospitais.length > 0) {
        this.carregarLocaisAtendimentoHospitais()
      }
    } else if (!temRoleAmbulatorio && this.possuiAcessoSecretariaAmbulatorio) {
      this.possuiAcessoSecretariaAmbulatorio = false
      const tipoUsuario = this.getConfigUsuarioStore.usuarioAgendamento.tipoUsuarioAgendamento
      if (tipoUsuario !== 'SecretariaDoAmbulatorio') {
        this.hospitaisConfigurados = []
      }
    }
  }

  sincronizarHospitaisConfigurados(hospitaisIds: string[]) {
    if (hospitaisIds.length === 0) {
      this.hospitaisConfigurados = []
      return
    }

    const novosHospitaisConfigurados: any[] = hospitaisIds.map((hospitalId) => {
      const hospitalExistente = this.hospitaisConfigurados.find(h => h.hospitalId === hospitalId)

      if (hospitalExistente) {
        return hospitalExistente
      }

      const hospital = this.hospitais.find(h => h.id === hospitalId)
      if (hospital) {
        this.buscarLocaisParaHospital(hospitalId)

        return {
          hospitalId: hospital.id,
          hospitalNome: hospital.nome,
          locais: [],
          locaisAtendimento: [],
        }
      }

      return null
    }).filter(h => h !== null)

    this.hospitaisConfigurados = novosHospitaisConfigurados
  }

  async buscarLocaisParaHospital(hospitalId: string) {
    try {
      const response = await Apis.Agendamento.SuporteApi.getAllLocaisDeAtendimentoEMedicos([hospitalId])

      if (response.success && response.data && response.data.locaisAtendimento) {
        const hospital = this.hospitaisConfigurados.find(h => h.hospitalId === hospitalId)
        if (hospital) {
          hospital.locais = response.data.locaisAtendimento.map((local: any) => ({
            id: local.id,
            nome: local.nome,
            hospitalId: _.toUpper(local.hospitalId),
            naoEditarInformacoesAdicionais: false,
          }))
        }
      }
    } catch (error) {
      console.error('Erro ao buscar locais de atendimento:', error)
    }
  }

  async buscarLocaisParaHospitais(hospitaisIds: string[]) {
    try {
      const response = await Apis.Agendamento.SuporteApi.getAllLocaisDeAtendimentoEMedicos(hospitaisIds)

      if (response.success && response.data && response.data.locaisAtendimento) {
        response.data.locaisAtendimento.forEach((local: any) => {
          const hospitalIdUpper = _.toUpper(local.hospitalId)
          const hospital = this.hospitaisConfigurados.find(h => h.hospitalId === hospitalIdUpper)

          if (hospital) {
            if (!hospital.locais) {
              hospital.locais = []
            }
            hospital.locais.push({
              id: local.id,
              nome: local.nome,
              hospitalId: hospitalIdUpper,
              naoEditarInformacoesAdicionais: false,
            })
          }
        })
      }
    } catch (error) {
      console.error('Erro ao buscar locais de atendimento:', error)
    }
  }

  async init() {
    // A store é singleton: sem isso, reabrir a tela mostraria a busca anterior sem a paginação.
    this.getConfigUsuarioStore.setBuscaPessoaRealizada(false)
    this.getConfigUsuarioStore.setSearchPessoa('')
    this.getConfigUsuarioStore.setTipoBuscaPessoa('nome')
    this.getConfigUsuarioStore.clearUsuarios()
    this.getConfigUsuarioStore.clearPagination()

    this.readyState = true
  }

  async mounted() {
    await this.init()
  }
}
